import type { ReactNode } from "react";
import { t } from "../../i18n";
import { BrandLockup } from "../ui/primitives";

/** The sign-in view from the mockup: brand line and one card at a time. The brand line is the
 *  lockup the owner picked (2026-10-08). */
export function AuthFrame({ children }: { children: ReactNode }) {
  return (
    <div className="view on" id="signin">
      <div className="auth">
        <div className="auth-brand">
          <BrandLockup />
          <div className="ab-sub">{t("shell.tagline")}</div>
        </div>
        <div className="auth-grid">{children}</div>
      </div>
    </div>
  );
}
